import React from 'react';
import moment from 'moment';

const EventDateViewer = ({ postInfo, dateFormat = 'YYYY.MM.DD' }) => {
  let startEventDate = '';
  let endEventDate = '';
  if (postInfo && postInfo.data && postInfo.data.event_info) {
    startEventDate = moment(postInfo.data.event_info.start_date).format(
      dateFormat
    );
    endEventDate = moment(postInfo.data.event_info.end_date).format(dateFormat);
  }
  return (
    <span className="date">
      기간 : {startEventDate}~{endEventDate}
    </span>
  );
};

export default EventDateViewer;
